













































































import { Component, Vue } from 'vue-property-decorator';

import { treatError } from '@/utils';
import isMobile from '@/utils/mobile-check';

import ReferralService from '@/api/ReferralService';

import {
  IBusinessReferral,
  EBusinessReferralDiscountType,
  TBusinessReferralType,
  EBusinessReferralType
} from '@/models/marketingCenter/referral';
import ReferralBoth from '@/components/icons/ReferralBoth.vue';
import ReferralNew from '@/components/icons/ReferralNew.vue';
import ReferralExisting from '@/components/icons/ReferralExisting.vue';

import { Surface, Typography } from '@/components/atoms';
import { FilledButton, ContentContainer } from '@/components/molecules';
import ChangeTypeReferral from '@/components/organisms/Referral/ChangeTypeReferral.vue';
import SetupReferral from '@/components/organisms/Referral/SetupReferral.vue';

interface IBreadcumbItem {
  label: string;
  path: string;
}

@Component({
  components: {
    Surface,
    Typography,
    FilledButton,
    ContentContainer,
    ChangeTypeReferral,
    SetupReferral,
    ReferralBoth,
    ReferralNew,
    ReferralExisting
  }
})
export default class ReferralEdit extends Vue {
  referralService = new ReferralService();
  campaign: IBusinessReferral = {};
  type: TBusinessReferralType = EBusinessReferralType.BOTH;
  coins: string | number = '';
  percentage: string | number = '';
  errors = [];
  loading = false;
  loadingCampaign = false;

  get tPrefix() {
    return `referralProgram`;
  }

  get disabledNext() {
    if (this.type === EBusinessReferralType.REFERRED)
      return !this.percentage || this.percentage <= 0;

    if (this.type === EBusinessReferralType.REFERRING)
      return !this.coins || this.coins <= 0;

    return this.coins <= 0 || this.percentage <= 0;
  }

  get isMobileDevice() {
    return isMobile();
  }

  get campaignType() {
    if (!Number(this.campaign.referringDiscount))
      return EBusinessReferralType.REFERRED;
    if (!Number(this.campaign.referredDiscount))
      return EBusinessReferralType.REFERRING;

    return EBusinessReferralType.BOTH;
  }

  close() {
    this.$router.push('/referral-program');
  }

  validate() {
    return this.coins > 0 || this.percentage > 0;
  }

  get businessCurrency() {
    return this.$store.getters['internationalization/getCountrySettings']
      .currencySymbol;
  }

  get breadcrumb() {
    const arr: (IBreadcumbItem | string)[] = [
      {
        label: 'Referral Program',
        path: '/referral-program'
      }
    ];
    arr.push('Editing');

    return arr;
  }

  get isReferring() {
    return this.type === EBusinessReferralType.REFERRING;
  }

  get isReferred() {
    return this.type === EBusinessReferralType.REFERRED;
  }

  async save() {
    const validation = this.validate();

    if (!validation || !this.campaign.id) {
      this.$notification('Please fill the highlighted fields below', 's');
      return;
    }
    this.loading = true;

    const referral = {
      referringDiscount: this.coins,
      referringDiscountType: EBusinessReferralDiscountType.COINS,
      referredDiscount: this.percentage,
      referredDiscountType: EBusinessReferralDiscountType.PERCENTAGE,
      referringMinimumValue: '0',
      referredMinimumValue: '0',
      isActive: this.campaign.isActive,
      referredPrefix: 'R',
      referringPrefix: 'R'
    };

    const response = await this.referralService.updateReferral(
      this.campaign.id,
      referral
    );

    if (response.status === 200) {
      this.$router.push('/referral-program');
      this.$notification(
        String(this.$t(`${this.tPrefix}.edit.feedback.changed`))
      );
    }
    this.loading = false;
  }

  changeCoins(value: string) {
    this.coins = value;
  }

  changePercentage(value: string) {
    this.percentage = value;
  }

  async getReferralProgram() {
    try {
      this.loadingCampaign = true;
      this.$showLoaderWithLocker();

      this.referralService.disableInterception();
      const { data } = await this.referralService.getReferral();
      this.campaign = data;
      this.type = this.campaignType;
    } catch (e) {
      treatError(e);
    } finally {
      this.loadingCampaign = false;
      this.$hideLoader();
    }
  }

  changeType() {
    this.$analytics({
      eventCategory: 'Referral Program | Change campaign type link',
      eventAction: 'click',
      eventLabel: 'Clicked to change campaign type'
    });

    this.$router.push('/referral-program/edit-type');
  }

  async created() {
    await this.getReferralProgram();
    this.changeCoins(Number(this.campaign.referringDiscount).toString());
    this.changePercentage(Number(this.campaign.referredDiscount).toString());
  }
}
